import {
  notEmptyListOf1z9dexvzyo0sz as notEmptyListOf,
  NotEmptyList__toList_impl_nbkblo1xb1zjd6musb4 as NotEmptyList__toList_impl_nbkblo,
  NotEmptyList3lrchpxsqrpb2 as NotEmptyList,
  _NotEmptyList___get_tail__impl__3z1zi81rb3cv4yxqpfw as _NotEmptyList___get_tail__impl__3z1zi8,
  _NotEmptyList___get_head__impl__zp2swu0zs1qn8pqty as _NotEmptyList___get_head__impl__zp2sw,
  NotEmptyList__toString_impl_vyyy953tw060zmkvhkj as NotEmptyList__toString_impl_vyyy95,
  NotEmptyList__hashCode_impl_a7t1ga1icu5nxpmmumo as NotEmptyList__hashCode_impl_a7t1ga,
} from '../../../../../../types-types/kotools/types/collection/NotEmptyList.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  plus310ted5e4i90h as plus,
  joinToString1cxrrlmo0chqs as joinToString,
  first58ocm7j58k3q as first,
  slice2g43wio9c6zdv as slice,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { CallSign1tjdkp2izdbad as CallSign } from '../player/callsign/CallSign.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NotBlankString__toString_impl_5tex9r2ig2s5isyc5ve as NotBlankString__toString_impl_5tex9r } from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import { get_displayName1mxts16oy93j as get_displayName } from '../player/Player.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SingleClass;
function Single() {
  if (SingleClass === VOID) {
    class $ extends CouplingPair() {
      constructor(player) {
        super();
        this.g2b_1 = player;
      }
      h2b() {
        return notEmptyListOf(this.g2b_1, []);
      }
      toString() {
        return 'Single(player=' + this.g2b_1.toString() + ')';
      }
      hashCode() {
        return this.g2b_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Single()))
          return false;
        if (!this.g2b_1.equals(other.g2b_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Single');
    SingleClass = $;
  }
  return SingleClass;
}
var DoubleClass;
function Double() {
  if (DoubleClass === VOID) {
    class $ extends CouplingPair() {
      constructor(player1, player2) {
        super();
        this.i2b_1 = player1;
        this.j2b_1 = player2;
      }
      h2b() {
        return notEmptyListOf(this.i2b_1, [this.j2b_1]);
      }
      toString() {
        return 'Double(player1=' + this.i2b_1.toString() + ', player2=' + this.j2b_1.toString() + ')';
      }
      hashCode() {
        var result = this.i2b_1.hashCode();
        result = imul(result, 31) + this.j2b_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Double()))
          return false;
        if (!this.i2b_1.equals(other.i2b_1))
          return false;
        if (!this.j2b_1.equals(other.j2b_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Double');
    DoubleClass = $;
  }
  return DoubleClass;
}
var MobClass;
function Mob() {
  if (MobClass === VOID) {
    class $ extends CouplingPair() {
      constructor(player1, player2, player3, more) {
        super();
        this.k2b_1 = player1;
        this.l2b_1 = player2;
        this.m2b_1 = player3;
        this.n2b_1 = more;
      }
      h2b() {
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = plus(listOf([this.l2b_1, this.m2b_1]), this.n2b_1);
        var tmp$ret$0 = copyToArray(this_0);
        return notEmptyListOf(this.k2b_1, tmp$ret$0.slice());
      }
      toString() {
        return 'Mob(player1=' + this.k2b_1.toString() + ', player2=' + this.l2b_1.toString() + ', player3=' + this.m2b_1.toString() + ', more=' + toString(this.n2b_1) + ')';
      }
      hashCode() {
        var result = this.k2b_1.hashCode();
        result = imul(result, 31) + this.l2b_1.hashCode() | 0;
        result = imul(result, 31) + this.m2b_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.n2b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Mob()))
          return false;
        if (!this.k2b_1.equals(other.k2b_1))
          return false;
        if (!this.l2b_1.equals(other.l2b_1))
          return false;
        if (!this.m2b_1.equals(other.m2b_1))
          return false;
        if (!equals(this.n2b_1, other.n2b_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Mob');
    MobClass = $;
  }
  return MobClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CouplingPairClass;
function CouplingPair() {
  if (CouplingPairClass === VOID) {
    class $ {
      w2a() {
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = NotEmptyList__toList_impl_nbkblo(this.h2b());
        return copyToArray(this_0);
      }
      p1() {
        return NotEmptyList__toList_impl_nbkblo(this.h2b()).p1();
      }
    }
    initMetadataForClass($, 'CouplingPair');
    CouplingPairClass = $;
  }
  return CouplingPairClass;
}
function get_pairId(_this__u8e3s4) {
  return joinToString(_this__u8e3s4, '-', VOID, VOID, VOID, VOID, _get_pairId_$lambda_m5yvaj);
}
function get_pairName(_this__u8e3s4) {
  var tmp = KProperty1();
  return joinToString(_this__u8e3s4, '-', VOID, VOID, VOID, VOID, getPropertyCallableRef('displayName', 1, tmp, _get_displayName_$ref_dpnhdf(), null));
}
function toCouplingPair(_this__u8e3s4) {
  switch (_this__u8e3s4.q2()) {
    case 1:
      return new (Single())(first(_this__u8e3s4));
    case 2:
      return new (Double())(_this__u8e3s4.r2(0), _this__u8e3s4.r2(1));
    default:
      return new (Mob())(_this__u8e3s4.r2(0), _this__u8e3s4.r2(1), _this__u8e3s4.r2(2), toSet(slice(_this__u8e3s4, until(3, _this__u8e3s4.q2()))));
  }
}
function pairOf(player1) {
  return new (Single())(player1);
}
var PinnedCouplingPairClass;
function PinnedCouplingPair() {
  if (PinnedCouplingPairClass === VOID) {
    class $ {
      constructor(pinnedPlayers, pins) {
        pins = pins === VOID ? emptySet() : pins;
        this.o2b_1 = pinnedPlayers;
        this.p2b_1 = pins;
      }
      q2b() {
        // Inline function 'kotlin.with' call
        var $this$with = this.o2b_1;
        var tail = _NotEmptyList___get_tail__impl__3z1zi8($this$with);
        var tmp;
        var tmp_0 = tail;
        if ((tmp_0 == null ? null : new (NotEmptyList())(tmp_0)) == null) {
          tmp = pairOf(_NotEmptyList___get_head__impl__zp2sw($this$with).r2b_1);
        } else {
          tmp = pairOf_0(_NotEmptyList___get_head__impl__zp2sw($this$with).r2b_1, _NotEmptyList___get_head__impl__zp2sw(tail).r2b_1);
        }
        return tmp;
      }
      t2b(pinnedPlayers, pins) {
        return new (PinnedCouplingPair())(pinnedPlayers, pins);
      }
      u2b(pinnedPlayers, pins, $super) {
        pinnedPlayers = pinnedPlayers === VOID ? this.o2b_1 : pinnedPlayers;
        pins = pins === VOID ? this.p2b_1 : pins;
        return $super === VOID ? this.t2b(pinnedPlayers, pins) : $super.t2b.call(this, new (NotEmptyList())(pinnedPlayers), pins);
      }
      toString() {
        return 'PinnedCouplingPair(pinnedPlayers=' + NotEmptyList__toString_impl_vyyy95(this.o2b_1) + ', pins=' + toString(this.p2b_1) + ')';
      }
      hashCode() {
        var result = NotEmptyList__hashCode_impl_a7t1ga(this.o2b_1);
        result = imul(result, 31) + hashCode(this.p2b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedCouplingPair()))
          return false;
        if (!equals(this.o2b_1, other.o2b_1))
          return false;
        if (!equals(this.p2b_1, other.p2b_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedCouplingPair');
    PinnedCouplingPairClass = $;
  }
  return PinnedCouplingPairClass;
}
var PinnedPlayerClass;
function PinnedPlayer() {
  if (PinnedPlayerClass === VOID) {
    class $ {
      constructor(player, pins) {
        this.r2b_1 = player;
        this.s2b_1 = pins;
      }
      v2b(player, pins) {
        return new (PinnedPlayer())(player, pins);
      }
      w2b(player, pins, $super) {
        player = player === VOID ? this.r2b_1 : player;
        pins = pins === VOID ? this.s2b_1 : pins;
        return $super === VOID ? this.v2b(player, pins) : $super.v2b.call(this, player, pins);
      }
      toString() {
        return 'PinnedPlayer(player=' + this.r2b_1.toString() + ', pins=' + toString(this.s2b_1) + ')';
      }
      hashCode() {
        var result = this.r2b_1.hashCode();
        result = imul(result, 31) + hashCode(this.s2b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayer()))
          return false;
        if (!this.r2b_1.equals(other.r2b_1))
          return false;
        if (!equals(this.s2b_1, other.s2b_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayer');
    PinnedPlayerClass = $;
  }
  return PinnedPlayerClass;
}
function callSign(_this__u8e3s4) {
  var pair = _this__u8e3s4.q2b().h2b();
  var nounPlayer = _NotEmptyList___get_head__impl__zp2sw(pair);
  var tmp0_safe_receiver = _NotEmptyList___get_tail__impl__3z1zi8(pair);
  var tmp;
  var tmp_0 = tmp0_safe_receiver;
  if ((tmp_0 == null ? null : new (NotEmptyList())(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = _NotEmptyList___get_head__impl__zp2sw(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var adjectivePlayer = tmp1_elvis_lhs == null ? nounPlayer : tmp1_elvis_lhs;
  var adjective = adjectivePlayer.b2b_1;
  var noun = nounPlayer.c2b_1;
  return new (CallSign())(adjective, noun);
}
function get_players(_this__u8e3s4) {
  // Inline function 'com.zegreatrob.coupling.model.map' call
  var this_0 = _this__u8e3s4.o2b_1;
  var tmp = _NotEmptyList___get_head__impl__zp2sw(this_0).r2b_1;
  var tmp0_safe_receiver = _NotEmptyList___get_tail__impl__3z1zi8(this_0);
  var tmp_0;
  var tmp_1 = tmp0_safe_receiver;
  if ((tmp_1 == null ? null : new (NotEmptyList())(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = NotEmptyList__toList_impl_nbkblo(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var _iterator__ex2g4s = tmp1_safe_receiver.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$4 = item.r2b_1;
      destination.i2(tmp$ret$4);
    }
    tmp_2 = destination;
  }
  var tmp2_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp2_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  return notEmptyListOf(tmp, tmp_4.slice());
}
function pairOf_0(player1, player2) {
  return new (Double())(player1, player2);
}
function withPins(_this__u8e3s4, pins) {
  pins = pins === VOID ? emptySet() : pins;
  // Inline function 'com.zegreatrob.coupling.model.map' call
  var this_0 = _this__u8e3s4.h2b();
  var player = _NotEmptyList___get_head__impl__zp2sw(this_0);
  var tmp = withPins_1(player);
  var tmp0_safe_receiver = _NotEmptyList___get_tail__impl__3z1zi8(this_0);
  var tmp_0;
  var tmp_1 = tmp0_safe_receiver;
  if ((tmp_1 == null ? null : new (NotEmptyList())(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = NotEmptyList__toList_impl_nbkblo(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var _iterator__ex2g4s = tmp1_safe_receiver.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$4 = withPins_1(item);
      destination.i2(tmp$ret$4);
    }
    tmp_2 = destination;
  }
  var tmp2_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp2_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  var tmp$ret$0 = notEmptyListOf(tmp, tmp_4.slice());
  return new (PinnedCouplingPair())(tmp$ret$0, pins);
}
function withPins_0(_this__u8e3s4) {
  // Inline function 'com.zegreatrob.coupling.model.map' call
  var p0 = _NotEmptyList___get_head__impl__zp2sw(_this__u8e3s4);
  var tmp = withPins(p0);
  var tmp0_safe_receiver = _NotEmptyList___get_tail__impl__3z1zi8(_this__u8e3s4);
  var tmp_0;
  var tmp_1 = tmp0_safe_receiver;
  if ((tmp_1 == null ? null : new (NotEmptyList())(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = NotEmptyList__toList_impl_nbkblo(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var _iterator__ex2g4s = tmp1_safe_receiver.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$4 = withPins(item);
      destination.i2(tmp$ret$4);
    }
    tmp_2 = destination;
  }
  var tmp2_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp2_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  return notEmptyListOf(tmp, tmp_4.slice());
}
function withPins_1(_this__u8e3s4, pins) {
  pins = pins === VOID ? emptyList() : pins;
  return new (PinnedPlayer())(_this__u8e3s4, pins);
}
function _get_pairId_$lambda_m5yvaj(it) {
  return NotBlankString__toString_impl_5tex9r(it.x2a_1.x2b_1);
}
function _get_displayName_$ref_dpnhdf() {
  return (p0) => get_displayName(p0);
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Double as Double32fogsljf31b1,
  PinnedCouplingPair as PinnedCouplingPair2b955okagel53,
  PinnedPlayer as PinnedPlayer2ydg21cly1nl1,
  callSign as callSignej8g32eqhquf,
  get_pairId as get_pairId17ekbda4ugyhg,
  get_pairName as get_pairName1swn4cuiimab3,
  pairOf_0 as pairOf3vr52fdd2zexd,
  pairOf as pairOf3e832z5sy0jiu,
  get_players as get_players1sz7rz6glqiyb,
  toCouplingPair as toCouplingPair2pztyujdw46m4,
  withPins as withPins10vez28uvca2x,
  withPins_0 as withPins352yl9ie2njao,
};
//endregion

//# sourceMappingURL=CouplingPair.mjs.map
